import { Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import moment from "moment";
import { useMemo } from "react";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import colors from "core/resources/theme/colors";
import { HiArrowNarrowRight } from "react-icons/hi";
import { TransferenciaItem } from "core/features/transferencia/typings";

function useTransferenciaListagemColumns() {
  return useMemo(() => {
    return [
      {
        title: "Data",
        width: "10%",
        render: (original: TransferenciaItem) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {moment(original.data).format("DD/MM/YYYY")}
          </Text>
        ),
      },
      {
        title: "Conta Origem",
        width: "35%",
        render: (original: TransferenciaItem) => (
          <Flex flexDir="column">
            <Text fontSize={14} lineHeight={"18px"} color={colors.black900}>
              {original.contaOrigem.nome}
            </Text>
            {original.contaOrigem.banco ? (
              <Text fontSize={14} lineHeight={"18px"} color={colors.black600}>
                ({original.contaOrigem.banco}, {original.contaOrigem.agencia} /{" "}
                {original.contaOrigem.conta})
              </Text>
            ) : null}
            {original.categoriaFinanceiraEnvio ? (
              <Text fontSize={12} lineHeight={"17px"} color={colors.black600}>
                {original.categoriaFinanceiraEnvio.breadcrumb} -{" "}
                {original.categoriaFinanceiraEnvio.nome}
              </Text>
            ) : null}
          </Flex>
        ),
      },
      {
        title: "",
        width: "10%",
        render: () => (
          <Flex flex={1} justifyContent="center">
            <HiArrowNarrowRight fontSize={40} color={colors.primary} />
          </Flex>
        ),
      },
      {
        title: "Conta Destino",
        width: "35%",
        render: (original: TransferenciaItem) => (
          <Flex flexDir="column">
            <Text fontSize={14} lineHeight={"18px"} color={colors.black900}>
              {original.contaDestino.nome}
            </Text>
            {original.contaDestino.banco ? (
              <Text fontSize={14} lineHeight={"18px"} color={colors.black600}>
                ({original.contaDestino.banco}, {original.contaDestino.agencia}{" "}
                / {original.contaDestino.conta})
              </Text>
            ) : null}
            {original.categoriaFinanceiraRecebimento ? (
              <Text fontSize={12} lineHeight={"17px"} color={colors.black600}>
                {original.categoriaFinanceiraRecebimento.breadcrumb} -{" "}
                {original.categoriaFinanceiraRecebimento.nome}
              </Text>
            ) : null}
          </Flex>
        ),
      },
      {
        title: "Valor",
        width: "10%",
        render: (original: TransferenciaItem) => (
          <Text fontSize={14} lineHeight={"18px"} color={colors.black900}>
            R${formatCurrency(original.valor)}
          </Text>
        ),
      },
    ];
  }, []);
}

export default useTransferenciaListagemColumns;
